import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { highDollarResources, revisarResources } from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import useToken from "../useToken";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { FormControl, InputLabel, OutlinedInput } from "@material-ui/core";
import DialogEditarCantidadConteo from "../components/DialogEditarCantidadConteo";
import DialogEliminarConteo from "../components/DialogEliminarConteo";
import CheckIcon from "@material-ui/icons/Check";
import BlockIcon from "@material-ui/icons/Block";
import AgregarConteo from "../components/AgregarConteo";
import AddIcon from "@material-ui/icons/Add";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataGrid } from "@mui/x-data-grid";
import { Redirect } from "react-router-dom";

class HighDollar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openSnack: false,
            severity: null,
            message: null,
            user: useToken.getUser(),
            datos_inv: useToken.getDatos(),
            valor: 10,
            value: "codigos",
            cargando: true,
            rowData: null,
            editar_cantidad: false,
            eliminar_conteo: false,
            tipo_conteo: "agrupado",
            revisar: false,
            desrevisar: false,
            agregar_conteo: false,
            hora: this.props.location.date || "00:00:00",
            selectedRow: null,
            datos: [],

        };
    }

    getHighDollar = () => {
        let date_utc_format;
        if (this.state.hora !== 'bodega') {
            this.setState({openSnack: false, severity: null, message: null})
            let fecha = this.generaFechaHigh(this.state.datos_inv.fecha, this.state.hora)
            const date_utc = new Date(fecha).toUTCString()
            const date_utc_format_list = new Date(date_utc).toISOString().split('Z')[0].split('.')[0].split('T')
            date_utc_format = date_utc_format_list[0] + ' ' + date_utc_format_list[1]
        } else {
            date_utc_format = this.state.hora
        }
        highDollarResources.getHighDollar(date_utc_format, this.state.valor, this.state.value).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if (result.status_code === 200) {
                this.setState({cargando: false, datos: result.high})
            } else if (result.status_code === 401) {
                this.setState({cargando: false, openSnack: true, severity: result.severity, message: result.message})
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            console.log(error)
        });
    };


    handleChange2 = e =>{
        this.setState({[e.target.name]: e.target.value, cargando : true});
    }

    revisarConteo = (rowData) =>{
        let origen = 'high_dollar'
        if(this.state.tipo_conteo === "desagrupado"){
            revisarResources.revisarConteo(rowData.id,origen).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.revisarConteoAgrupado(rowData.tag,rowData.codigo,rowData.id_codigo_tipo,origen,origen).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    desrevisarConteo = (rowData) =>{
        if(this.state.tipo_conteo === "desagrupado"){
            revisarResources.desrevisarConteo(rowData.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.desrevisarContepAgrupado(rowData.tag,rowData.codigo,rowData.id_codigo_tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    eliminarConteo = (rowData) =>{
        this.setState({rowData:rowData, eliminar_conteo: true})
    }

    editarConteo = (rowData) =>{
        if (this.state.user.app === 'tottus'){
            this.setState({tipo_conteo: 'agrupado'})
        }
        this.setState({rowData:rowData, editar_cantidad: true})
    }

    generaFechaHigh = (fecha_inventario,hora) =>{
        if (this.state.datos_inv.centro_descripcion.includes('EXPRESS400') ||this.state.datos_inv.centro_descripcion.includes('MAYORISTA') ){
            fecha_inventario = new Date(fecha_inventario+ 'T'+hora)
        }
        else{
            if (hora === '22:00:00'){
                fecha_inventario = fecha_inventario+'T'+ hora;
            }
            else if (hora === '23:00:00'){
                fecha_inventario = fecha_inventario+'T'+ hora;
            }
            else{
                fecha_inventario = new Date(fecha_inventario+'T'+hora);
                fecha_inventario.setDate(fecha_inventario.getDate() + 1);
                fecha_inventario = new Date(fecha_inventario.toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0]
            }
        }
        return fecha_inventario
    }

    handleClose = () =>{
        this.setState({editar_cantidad:false, eliminar_conteo:false,revisar:false,desrevisar:false,agregar_conteo:false})
    }

    refrescar = (estado,severity) =>{
        this.setState({editar_cantidad:false, eliminar_conteo: false, openSnack:false,
            agregar_conteo:false,severity: null, message:null,revisar:false,desrevisar:false}, ()=>{
            if(severity === "success"){
                this.getHighDollar()
            }
            // pequeño delay para reabrir el snack
            setTimeout(() => {
                this.setState({
                    openSnack: true,
                    severity: severity,
                    message: estado,
                });
            }, 50);
        })
    }

    getColumnVisibilityModel = () => {
        const hideForWalmart = this.state.user.app !== 'walmart' && this.state.user.app !== 'walmart_parciales';

        return {
            departamento: !hideForWalmart,
            hora: !hideForWalmart,
            bin: !hideForWalmart,
        };
    };

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            if (this.props.location.date) {
                this.getHighDollar();
            }
        }
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            const { datos, sortField, sortDir } = this.state;


            const columns = [
                {
                    field: "departamento",
                    headerName: "Depto.",
                    sortable: false,
                    flex: 1, minWidth: 100,
                },
                {
                    field: "hora",
                    headerName: "Hora",
                    sortable: false,
                    flex: 1, minWidth: 150,
                },
                { field: "tag", headerName: "Tag", flex: 1, minWidth: 130,},
                { field: "bin", headerName: "Bin", flex: 1, minWidth: 130,sortable: false,},
                { field: "articulo", headerName: "Material", flex: 1, minWidth: 150},
                { field: "codigo", headerName: "Cód.escan.", flex: 1, minWidth: 150, sortable: false,},
                { field: "descripcion", headerName: "Descripción", flex: 1, minWidth: 260,sortable: false,},
                { field: "precio", headerName: "Precio", flex: 1, minWidth: 100,},
                { field: "importe", headerName: "Valor", flex: 1, minWidth: 120,},
                { field: "cantidad", headerName: "Cant.Capt", flex: 1, minWidth: 130,},
                {
                    field: "revisado",
                    headerName: "Revisado",
                    flex: 1, minWidth: 80,
                    sortable: false,
                    renderCell: (params) => (params.value ? <CheckIcon /> : null),
                },
                {
                    field: "acciones",
                    sortable: false,
                    headerName: "Acciones",
                    flex: 1, minWidth: 120,
                    renderCell: (params) => {
                        if (params.row.hora === 'Subtotal') {
                            return null; // no muestra íconos
                        }

                        return (
                            <div style={{ display: "flex", gap: 4 }}>
                                {!params.row.revisado && (
                                    <CheckIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.revisarConteo(params.row)}
                                    />
                                )}
                                {params.row.revisado && (
                                    <BlockIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.desrevisarConteo(params.row)}
                                    />
                                )}
                                <CreateIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.editarConteo(params.row)}
                                />
                                <DeleteIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.eliminarConteo(params.row)}
                                />
                            </div>
                        );
                    },

                },
            ];

            return (
                <div>
                    <Typography variant="h4" gutterBottom>
                        High Dollar
                    </Typography>

                    {/* Controles superiores (Hora, Valor, etc.) */}
                    <Grid container justifyContent={"flex-start"} direction={'row'} spacing={2} style={{padding:10, marginBottom:10}}>
                        {(this.state.user.app === 'walmart' || this.state.user.app === 'walmart_parciales')&&
                            <Grid item xs={2}>
                                <Grid container>
                                    {((this.state.datos_inv.centro_descripcion).includes('EXPRESS400') || (this.state.datos_inv.centro_descripcion).includes('MAYORISTA')) &&
                                        <FormControl variant="outlined" style={{minWidth: 200,}}>
                                            <InputLabel htmlFor="outlined-age-native-simple">Hora</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                value={this.state.hora}
                                                name={'hora'}
                                                onChange={this.handleChange2}
                                                label="Hora">
                                                <MenuItem value={'bodega'}>Bodega</MenuItem>
                                                <MenuItem value={'07:00:00'}>07:00</MenuItem>
                                                <MenuItem value={'08:00:00'}>08:00</MenuItem>
                                                <MenuItem value={'09:00:00'}>09:00</MenuItem>
                                                <MenuItem value={'10:00:00'}>10:00</MenuItem>
                                                <MenuItem value={'11:00:00'}>11:00</MenuItem>
                                                <MenuItem value={'12:00:00'}>12:00</MenuItem>
                                                <MenuItem value={'13:00:00'}>13:00</MenuItem>
                                            </Select>
                                        </FormControl>}
                                    {!((this.state.datos_inv.centro_descripcion).includes('EXPRESS400')) &&  !((this.state.datos_inv.centro_descripcion).includes('MAYORISTA')) &&
                                        <FormControl variant="outlined" style={{minWidth: 200,}}>
                                            <InputLabel htmlFor="outlined-age-native-simple">Hora</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                value={this.state.hora}
                                                name={'hora'}
                                                onChange={this.handleChange2}
                                                label="Hora"
                                            >
                                                <MenuItem value={'bodega'}>Bodega</MenuItem>
                                                <MenuItem value={'22:00:00'}>22:00</MenuItem>
                                                <MenuItem value={'23:00:00'}>23:00</MenuItem>
                                                <MenuItem value={'00:00:00'}>00:00</MenuItem>
                                                <MenuItem value={'01:00:00'}>01:00</MenuItem>
                                                <MenuItem value={'02:00:00'}>02:00</MenuItem>
                                                <MenuItem value={'03:00:00'}>03:00</MenuItem>
                                                <MenuItem value={'04:00:00'}>04:00</MenuItem>
                                                <MenuItem value={'05:00:00'}>05:00</MenuItem>
                                                <MenuItem value={'06:00:00'}>06:00</MenuItem>
                                            </Select>
                                        </FormControl>}

                                </Grid>
                            </Grid>}
                        {(this.state.user.app !== 'walmart' && this.state.user.app !== 'walmart_parciales'  && this.state.user.app !== 'tottus' )&&
                            <Grid item xs={1}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Valor</InputLabel>
                                    <OutlinedInput value={this.state.valor} type={'number'}  name="valor" onChange={this.handleChange2}
                                                labelWidth={35}
                                    />
                                </FormControl>
                            </Grid>}
                        {(this.state.user.app !== 'walmart' && this.state.user.app !== 'walmart_parciales' && this.state.user.app !== 'tottus' ) &&
                            <Grid item>
                                <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="value" value={this.state.value} onChange={this.handleChange2}>
                                    <FormControlLabel value="codigos" control={<Radio/>} label="N° códigos" />
                                    <FormControlLabel value="monto" control={<Radio/>} label="Monto" />
                                </RadioGroup>
                            </Grid>}
                        <Grid item>
                            <Button size="large" variant="contained" color="primary" onClick={()=>this.getHighDollar()}>
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>

                    {!this.state.cargando && (
                        <div style={{ height: "100%", width: "100%" }}>
                            {/* Toolbar con botón Agregar Conteo */}
                            <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{ padding: 10, marginBottom: 10 }}>
                                <Grid item>
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.setState({ agregar_conteo: true })}
                                    >
                                        Agregar conteo
                                    </Button>
                                </Grid>
                            </Grid>
                            <DataGrid
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 50,
                                            page: 0,
                                        },
                                    },
                                }}
                                pageSizeOptions={[25,50]}
                                rows={datos}
                                columns={columns}
                                columnVisibilityModel={this.getColumnVisibilityModel()}
                                getRowId={(row) => row.id}
                                onRowClick={(params) => this.setState({ selectedRow: params.id })}
                                getRowClassName={(params) =>
                                    [
                                        params.id === this.state.selectedRow ? "row-selected" : "",
                                        params.row.isSubtotal ? "subtotal-row" : "",
                                    ].join(" ")
                                }
                                onSortModelChange={(model) => {
                                    if (model.length > 0) {
                                        const { field, sort } = model[0];
                                        this.setState({ sortField: field, sortDir: sort });
                                    }
                                }}
                                disableColumnMenu
                                sortingMode="server"
                                sortingOrder={["asc", "desc"]}
                                sx={{
                                    "& .row-selected": {
                                        backgroundColor: "#dbe9fc",
                                    },
                                    "& .subtotal-row": {
                                        fontWeight: "bold",
                                        backgroundColor: "#f0f0f0",
                                    },
                                }}
                            />
                        </div>
                    )}

                    {/* Alertas y diálogos */}
                    {this.state.openSnack && <SnackbarAlert severity={this.state.severity} message={this.state.message} />}
                    {this.state.editar_cantidad && (
                        <DialogEditarCantidadConteo
                            origen={"high_dollar"}
                            tag={this.state.rowData.tag}
                            refrescar={this.refrescar}
                            tipo={this.state.tipo_conteo}
                            handleClose={this.handleClose}
                            conteo={this.state.rowData}
                        />
                    )}
                    {this.state.eliminar_conteo && (
                        <DialogEliminarConteo
                            refrescar={this.refrescar}
                            tag={this.state.rowData.tag}
                            tipo={this.state.tipo_conteo}
                            handleClose={this.handleClose}
                            conteo={this.state.rowData}
                        />
                    )}
                    {this.state.agregar_conteo && (
                        <AgregarConteo
                            origen={"high_dollar"}
                            tag={""}
                            handleClose={this.handleClose}
                            refrescar={this.refrescar}
                            articulo={this.state.idProducto}
                        />
                    )}
                </div>
            );
        }
    }
}

export default HighDollar;
